module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "main"
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.innertext) + "\n\t")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9c14540"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Main.vue
// module id = 1302
// module chunks = 1